import {
	IFinishOperation,
	IOperation,
	OPERATION_TYPE,
	PROCESS_EXPIRED_DETAILS_CODE,
	PROCESS_STATUS,
} from '../models/user-identification';

/** Misma espera que el tile de FINISH OK/KO antes de `window.location`. */
export const FINISH_REDIRECT_DELAY_MS = 3000;

export interface ExpiredRedirectInput {
	primaryDevice?: boolean;
	statusProcessDevice?: PROCESS_STATUS;
	processStatusCode?: number | null;
	redirectCancelled?: string;
}

export function isProcessExpiredCode(code: number | string | null | undefined): boolean {
	return Number(code) === PROCESS_EXPIRED_DETAILS_CODE;
}

/** 1098 (cron) se trata como dispositivo CANCELLED para cortar poll y disparar caducado. */
export function resolveDeviceStatusForExpiry(
	deviceStatus: PROCESS_STATUS,
	processStatusCode: number | string | null | undefined,
): PROCESS_STATUS {
	return isProcessExpiredCode(processStatusCode) ? PROCESS_STATUS.CANCELLED : deviceStatus;
}

export function isDefinitiveDeviceStatus(deviceStatus: PROCESS_STATUS): boolean {
	return (
		deviceStatus === PROCESS_STATUS.OK ||
		deviceStatus === PROCESS_STATUS.KO ||
		deviceStatus === PROCESS_STATUS.CANCELLED
	);
}

/**
 * Redirect caducado: cron 1098, o device CANCELLED con code null
 * (idle ~30s en GET /process/status). Otros códigos (2FA, etc.) no.
 */
export function isCancelledRedirectEligible(
	statusProcessDevice: PROCESS_STATUS | undefined,
	processStatusCode: number | null | undefined,
): boolean {
	if (isProcessExpiredCode(processStatusCode)) {
		return true;
	}
	return (
		statusProcessDevice === PROCESS_STATUS.CANCELLED &&
		(processStatusCode === null || processStatusCode === undefined)
	);
}

export function pickFinishOperation(operations?: IOperation[] | null): IFinishOperation | undefined {
	const finishes = (operations ?? []).filter(
		(op): op is IFinishOperation => op.type === OPERATION_TYPE.FINISH,
	);
	return finishes.find((op) => Boolean(op.config?.redirect_cancelled)) ?? finishes[0];
}

export function finishHasRedirectUrls(finish: IFinishOperation | undefined): boolean {
	return Boolean(
		finish?.config?.redirect || finish?.config?.redirect_ko || finish?.config?.redirect_cancelled,
	);
}

export function shouldScheduleExpiredRedirect(
	input: ExpiredRedirectInput,
): input is ExpiredRedirectInput & { redirectCancelled: string } {
	return Boolean(
		input.primaryDevice &&
			input.redirectCancelled &&
			isCancelledRedirectEligible(input.statusProcessDevice, input.processStatusCode),
	);
}
